import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

/**
 * Public Language Switcher - Only for landing page and public pages
 * Uses separate localStorage key: 'publicLang'
 */
const PublicLanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'tr' : 'en';
    // Store in separate localStorage key for public pages
    localStorage.setItem('publicLang', newLang);
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border-2 border-lotus-gold text-lotus-gold hover:bg-lotus-gold hover:text-white transition-all font-semibold"
      aria-label={t('common.changeLanguage')}
    >
      <Globe size={16} />
      <span className="text-sm">{i18n.language === 'en' ? 'TR' : 'EN'}</span>
    </button>
  );
};

export default PublicLanguageSwitcher;
